<template>
  <div>
    <CHeader
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
    >
      <CHeaderBrand class="mx-auto" to="/">
        <img
          src="../assets/img/pickiddologolargesizewhite.png"
          height="48px"
          class="m-2"
        />
      </CHeaderBrand>

      <CDropdown color="light" class="m-2 d-sm-flex d-md-none" :caret="false">
        <template #toggler-content>
          <CIcon name="cil-justify-center" />
        </template>
        <!-- <CDropdownItem
          style="width: 100% !important"
          href="https://pickiddo.com/about"
        >
          ABOUT US</CDropdownItem
        >
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
        <CDropdownItem href="https://pickiddo.com/Tuition/UserGuide"
          >TUTORIAL</CDropdownItem
        > -->
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
        <!-- <CDropdownItem to="/SearchTutor">REGISTER</CDropdownItem> -->
        <CDropdownItem to="/Partner">JOIN AS PARTNER</CDropdownItem>
        <CDropdownItem href="/SearchTutor">
          <CButton color="danger" size="sm" shape="pill"
            >REGISTER</CButton
          ></CDropdownItem
        >
      </CDropdown>

      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3"> </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/"> HOMEPAGE </CHeaderNavLink>
        </CHeaderNavItem>
        <!-- <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/about" exact>
            ABOUT US
          </CHeaderNavLink>
        </CHeaderNavItem> -->
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Package">
            PRICING
          </CHeaderNavLink>
        </CHeaderNavItem>
        <!-- <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/SearchTutor">
            REGISTER
          </CHeaderNavLink>
        </CHeaderNavItem> -->
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Partner">
            JOIN AS PARTNER
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3 ml-3">
          <CHeaderNavLink href="/SearchTutor">
            <CButton color="danger" size="sm" shape="pill"
              >REGISTER</CButton
            ></CHeaderNavLink
          >
        </CHeaderNavItem>
      </CHeaderNav>
    </CHeader>
    <CJumbotron class="banner">
      <CRow>
        <CCol
          sm="12"
          lg="12"
          class="element-50 mt-5 text-center custom-center-pro"
        >
          <div>
            <h2
              style="font-weight: 700"
              class="custom-title-tutor text-white ml-5"
            >
              <b>Feature</b>
            </h2>
            <h4>
              Welcome to Pickiddo! We so glad you are here. Let's get started
            </h4>
          </div>
        </CCol>
      </CRow>
    </CJumbotron>
    <CCol sm="12" lg="12">
      <CContainer>
        <CRow>
          <CCol sm="12"
            ><CHeaderNavLink to="/help"
              ><span class="mb-3">Back to Help Page</span></CHeaderNavLink
            >
            <br
          /></CCol>
          <CCol sm="8" lg="8">
            <CCard>
              <div style="line-height: 2.5em" class="m-4">
                <h3 id="Whatpackage">What feature that Pickiddo have ?</h3>
                <p>
                  Pickiddo provide some feature for teacher and student suitable
                  with current era all is in online. Feature Pickiddo such as:
                </p>
                <h5>
                  <CBadge color="light" class="m-2">1. Profile</CBadge>
                  <CBadge color="light" class="m-2">2. Notifcation</CBadge>
                  <CBadge color="light" class="m-2">3. Support</CBadge>
                  <CBadge color="light" class="m-2">4. AskKiddo</CBadge>
                  <CBadge color="light" class="m-2">5. Tutor</CBadge>
                  <CBadge color="light" class="m-2">6. Payment</CBadge>
                  <CBadge color="light" class="m-2">7. EPay</CBadge>
                  <CBadge color="light" class="m-2">8. Class</CBadge>
                  <CBadge color="light" class="m-2">9. Quiz</CBadge>
                  <CBadge color="light" class="m-2">10. Find Tutor</CBadge>
                </h5>

                <hr />
                <h5 class="mt-3">1. Profile</h5>
                <p>
                  On profile, user can view or update their personal information
                  or add new student
                </p>

                <p>Update personal information</p>
                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1.png"
                    />
                    <label>Step 1: Click Profile</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-1.png"
                    />
                    <label>Step 2: Click Edit</label>
                  </CCol>
                  <CCol sm="4" lg="4">
                    <img
                      style="max-width: 100%"
                      src="../assets/img/step3-1.png"
                    />
                    <label>Step 3: Edit data and Save</label></CCol
                  >
                </CRow>

                <p>Add New Student</p>
                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1.png"
                    />
                    <label>Step 1: Click Profile</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2.png"
                    />
                    <label>Step 2: Click Add New</label>
                  </CCol>
                  <CCol sm="4" lg="4">
                    <img
                      style="max-width: 100%"
                      src="../assets/img/step3.png"
                    />
                    <label>Step 3: Fill form and Save</label></CCol
                  >
                </CRow>
                <hr />

                <h5 class="mt-3">2. Notification</h5>
                <p>
                  On this features, student and teacher will receive
                  notification such as reminder of the class, find tutor,
                  homework and so much more. User need to click one of the
                  notification and it will redirectly to the page based on
                  category of notification.
                </p>

                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-n.png"
                    />
                    <label>Step 1: Click Notification</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-n.png"
                    />
                    <label>Step 2: View list notification</label>
                  </CCol>
                </CRow>
                <hr />
                <h5 class="mt-3">3. Support</h5>
                <p>
                  This segment is for Pickiddo's support team to receive any
                  feedback, complaint, suggestion or any question regarding
                  Pickiddo App. If you need support, you can click one of the
                  list provided such as <b>Call, Email, Messenger</b> and
                  <b>whatsapp</b>.
                </p>

                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-su.png"
                    />
                    <label>Step 1: Click Support</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-s.png"
                    />
                    <label>Step 2: List Support</label>
                  </CCol>
                </CRow>
                <hr />
                <h5 class="mt-3">4. Setting</h5>
                <p>
                  In this feature, show the version of the Pickiddo App. If you
                  need help or guide on this app, you may click on help.
                </p>

                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-se.png"
                    />
                    <label>Step 1: Click Setting</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-se.png"
                    />
                    <label>Step 2: Click Help</label>
                  </CCol>
                </CRow>
                <hr />
                <h5 class="mt-3">5. AskKiddo</h5>
                <p>
                  In AskKiddo, Any user can share their knowledge on this
                  feature. If there is question about pickiddo, pickiddo team
                  will answer their question.
                </p>

                <h5>How to Add New</h5>
                <br />

                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-ask.png"
                    />
                    <label>Step 1: Click AskKiddo</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-ask.png"
                    />
                    <label>Step 2: Click Add New</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step3-ask.png"
                    />
                    <label>Step 2: Fill in the form and click Post</label>
                  </CCol>
                </CRow>

                <h5>How to Reply Comment</h5>
                <br />

                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-reask.png"
                    />
                    <label>Step 1: Click icon comment</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-reask.png"
                    />
                    <label>Step 2: Write your comment and send</label>
                  </CCol>
                </CRow>
                <hr />
                <h5 class="mt-3">6. Tutor</h5>
                <p>
                  In tutor, student can check class schedule,view attendance,
                  evaluation of each student on every their test and activity.
                  For tutor, tutor can view class schedule, attendance,
                  evaluation of each student on every their test, activity and
                  view tutor salary.
                </p>

                <h5>i. Attendance</h5>
                <br />

                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-tu.png"
                    />
                    <label>Step 1: Click Tutor</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-1-tu.png"
                    />
                    <label>Step 2: Click Attendance</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-tu.png"
                    />
                    <label>Step 3: Click box subject</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step3-tu.png"
                    />
                    <label>Step 3: List student attendance</label>
                  </CCol>
                </CRow>
                <br />
                <h5>ii. Schedule</h5>

                <h6>1. How to check Attendance class detail</h6>
                <br />
                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-sc.png"
                    />
                    <label>Step 1: Click Schedule</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-sc.png"
                    />
                    <label>Step 2: Click on each of list class </label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step3-sc.png"
                    />
                    <label>Step 3: View detail class check in and out</label>
                  </CCol>
                </CRow>
                <br />
                <h6>2. How to check Attendance schedule class</h6>
                <br />

                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-sche.png"
                    />
                    <label>Step 1: Click Schedule and click of each box</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-2-sche.png"
                    />
                    <label
                      >Step 2: Click on each of list class to view detail
                      class</label
                    >
                  </CCol>
                </CRow>
                <br />
                <h5>iii. Evaluation</h5>
                <b>For Teacher </b>
                <h6>1. How to add evaluation student based on exam ?</h6>
                <br />
                <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-eva.png"
                    />
                    <label>Step 1: Click Evaluation</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-eva.png"
                    />
                    <label
                      >Step 2: Click on each box
                      </label
                    >
                  </CCol>
                   <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step3-eva.png"
                    />
                    <label
                      >Step 3: Click Add New
                      </label
                    >
                  </CCol>
                   <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step4-eva.png"
                    />
                    <label
                      >Step 4: Fill the form
                      </label
                    >
                  </CCol>
                   <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step5-eva.png"
                    />
                    <label
                      >Step 5: Click student
                      </label
                    >
                  </CCol>
                   <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step6-eva.png"
                    />
                    <label
                      >Step 6: Click Edit and Start evaluate your student
                      </label
                    >
                  </CCol>
                </CRow>
                 <br />
                <h5>iv. Activity</h5>
                 <h6>1. How to know what activity that I have done in classroom ?</h6>
                  <CRow>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step1-eva.png"
                    />
                    <label>Step 1: Click Activity</label>
                  </CCol>
                  <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step2-eva.png"
                    />
                    <label
                      >Step 2: Click on each box of class
                      </label
                    >
                  </CCol>
                   <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step3-eva.png"
                    />
                    <label
                      >Step 3: Click Add New to add some comment for the class
                      </label
                    >
                  </CCol>
                   <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step4-eva.png"
                    />
                    <label
                      >Step 4: Fill the form and click Post
                      </label
                    >
                  </CCol>
                   <CCol sm="4" lg="4"
                    ><img
                      style="max-width: 100%"
                      src="../assets/img/step5-eva.png"
                    />
                    <label
                      >Step 5: Show list of comment
                      </label
                    >
                  </CCol>
                  
                </CRow>

                <br />

              </div>
            </CCard>
          </CCol>
          <CCol sm="4" lg="4">
            <CCard>
              <div style="line-height: 2.5em" class="m-4">
                <h4>Help</h4>

                <CIcon name="cil-notes" height="20px" class="mr-2" />
                <a href="#Whatpackage">What package pickiddo provide ? </a>
                <br />
                <CIcon name="cil-notes" height="20px" class="mr-2" />
                <a href="#subscribepackage"
                  >How I can subscribe package provided ?
                </a>
                <br />
                <CIcon name="cil-notes" height="20px" class="mr-2" />
                <a href="#howmanypackage">
                  Can I subscribe more than one package ?
                </a>
                <br />
              </div>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </CCol>
  </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import backgroundCounter from "../assets/img/bgmap.png";
import backgroundUrlApps from "../assets/img/bg3Copy-1.png";
import backgroundCount from "../assets/img/Landingpage.png";

import video from "../assets/img/register.mp4";
import video2 from "../assets/img/register1.mp4";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import _ from "lodash";

export default {
  name: "Login",
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      successModal: false,
      CustomerName: "",
      CustomerEmail: "",
      CustomerPhoneNumber: "",

      backgroundCounter,
      backgroundCount,
      backgroundUrlApps,
      view: {
        topOfPage: true,
      },

      video,
      video2,

      slides: 7,
      autoplay: true,
      loop: true,
      playerOptions: {
        loop: true,
        autoplay: true,
      },
      playerOption: {},
      autoplay: {
        // automatically play the video
        type: Boolean,
        default: () => true,
      },
      loop: {
        // loop the video infinitely
        type: Boolean,
        default: () => true,
      },
      cardList: false,
      toggle: false,
    };
  },
  created() {
    AOS.init();
  },
  async mounted() {},
  methods: {
    GoToPageFaq() {
      this.$router.push("/Faq");
    },
    GotoWhatsap() {
      location.replace(
        "https://wa.me/600106597700?text=+Hi, I would like to ask about pickiddo "
      );
    },

    toggles: function (item) {
      item.isActive = !item.isActive;
    },

    navbarShow() {
      this.cardList = true;
    },
    GoToPagePro() {
      this.$router.push("/ProClass");
    },
    GotoLogin() {
      this.$router.push("https://pickiddo.com/TuitionCenter/Login");
    },
    GotoApple() {
      this.$router.push("https://apps.apple.com/my/app/pickiddo/id1366167288");
    },
    GotoGoogle() {
      this.$router.push(
        "https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
      );
    },

    ShowButtonSubmit() {
      this.ShowButton = true;
    },
  },
};
</script>


<style>
body {
  background: #fff;
  font-family: "Rubik", sans-serif;
}
.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000015;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

.custom-font {
  font-family: "Rubik", sans-serif;
}

.change_color {
  background-color: red;
}

* {
  padding: 0;
  margin: 0;
}

body {
  height: 100vh;
}
body nav {
  position: fixed;
  width: 100%;
  height: 70px;
  background-color: transparent;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}
body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}

.c-header {
  background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83;
  /* color: #fff; */
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1em;
  line-height: 1.5;
  border-radius: 0.3rem;
}
.item-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 120%;
  margin-bottom: 10px;
  font-weight: 500;
  color: #4a4a4a;
}

.item-desc {
  font-size: 14px;
  line-height: 140%;
  min-height: 60px;
}

.card .custom-hover:hover {
  transition: 0.15s all ease-in-out;
  transform: scale(1.1);
  z-index: 100;
  background-color: #fff;
}
.banner {
  position: relative;
  background-image: url(../assets/img/transparent.png),
    linear-gradient(-150deg, #174d7c 0%, #51baa9 97%);
  background-size: 380px, contain;
  background-position: center;
  color: #fff;
}

@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap");
</style>
